import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialKeyboardButtonDirection2: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.48 9.14h-6.1v1.53h-1.52v10.66h1.52v1.53h6.1v-1.53H32V10.67h-1.52Zm0 7.62h-1.53v1.52h-1.52v1.53h-1.52v-7.62h1.52v1.52h1.52v1.53h1.53ZM21.34 32v-1.52h1.52v-6.1h-1.52v-1.52H10.67v1.52H9.15v6.1h1.52V32Zm-9.15-6.1h7.62v1.53h-1.52v1.52h-1.53v1.53h-1.52v-1.53h-1.52v-1.52h-1.53ZM22.86 1.52h-1.52V0H10.67v1.52H9.15v6.1h1.52v1.52h10.67V7.62h1.52Zm-3.05 4.57h-7.62V4.57h1.53V3.05h1.52V1.52h1.52v1.53h1.53v1.52h1.52ZM7.62 22.86v-1.53h1.53V10.67H7.62V9.14H1.53v1.53H0v10.66h1.53v1.53Zm-6.09-7.62h1.52v-1.53h1.52v-1.52H6.1v7.62H4.57v-1.53H3.05v-1.52H1.53Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialKeyboardButtonDirection2
